import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './style.scss';
import Icon from '../../Icons';

const SidebarDt = ({ children, pathName, closeSidebar, location }) => {
  const { search } = location;
  const fullPath = `${pathName}${search}`;

  return (
    <div className="scroll-box">
      <Nav className="flex-column sidebar-dt-nav">
        <Nav.Link eventKey="welcome" as={Link} to="/dt/welcome" onClick={closeSidebar} active={pathName === 'welcome'}>
          <Icon icon="home-outline" />
          <span className="link-menu">Reportes DT</span>
        </Nav.Link>
        <Nav.Link
          eventKey="legal_reports"
          as={Link}
          to="/dt/legal_reports?tab=attendance-report"
          onClick={closeSidebar}
          active={fullPath === 'legal_reports?tab=attendance-report'}
        >
          <span className="link-menu">Reporte de Asistencia</span>
        </Nav.Link>
        <Nav.Link
          eventKey="legal_reports"
          as={Link}
          to="/dt/legal_reports?tab=workday-report"
          onClick={closeSidebar}
          active={fullPath === 'legal_reports?tab=workday-report'}
        >
          <span className="link-menu">Reporte de Jornada Diaria</span>
        </Nav.Link>
        <Nav.Link
          eventKey="legal_reports"
          as={Link}
          to="/dt/legal_reports?tab=offday-report"
          onClick={closeSidebar}
          active={fullPath === 'legal_reports?tab=offday-report'}
        >
          <span className="link-menu">Reporte de Días domingo y/o días festivos</span>
        </Nav.Link>
        <Nav.Link
          eventKey="legal_reports"
          as={Link}
          to="/dt/legal_reports?tab=shift-report"
          onClick={closeSidebar}
          active={fullPath === 'legal_reports?tab=shift-report'}
        >
          <span className="link-menu">Reporte de Modificaciones y/o alteraciones de turnos</span>
        </Nav.Link>
        <Nav.Link
          eventKey="legal_reports"
          as={Link}
          to="/dt/legal_reports?tab=daily_attendance"
          onClick={closeSidebar}
          active={fullPath === 'legal_reports?tab=daily_attendance'}
        >
          <span className="link-menu">REPORTE DIARIO</span>
        </Nav.Link>
        <Nav.Link
          eventKey="legal_reports"
          as={Link}
          to="/dt/attendances_control_clock/true"
          onClick={closeSidebar}
          active={pathName === 'attendances_control_clock'}
        >
          <span className="link-menu">REPORTE DE INCIDENTES TECNICOS</span>
        </Nav.Link>
        <Nav.Link
          eventKey="legal_reports"
          as={Link}
          to="/dt/documents"
          onClick={closeSidebar}
          active={pathName === 'documents'}
        >
          <span className="link-menu">Buscar Documentos</span>
        </Nav.Link>
        <Nav.Link
          eventKey="attendances_hash"
          as={Link}
          to="/dt/attendances_hash/true"
          onClick={closeSidebar}
          active={pathName === 'attendances_hash'}
        >
          <span className="link-menu">Busqueda por Hash</span>
        </Nav.Link>
        <Nav.Link
          eventKey="active_companies"
          as={Link}
          to="/dt/active_companies"
          onClick={closeSidebar}
          active={pathName === 'active_companies'}
        >
          <span className="link-menu">Empresas Vigentes</span>
        </Nav.Link>
        <div className="d-lg-none">{children}</div>
      </Nav>
    </div>
  );
};

export default SidebarDt;
